<template>
  <div>
    <div v-if="agreementType == 1">
      <div class="agreement-title">隐私政策</div>
      <div>
        <p>本政策将帮助您了解以下内容：</p>
        <p>一、我们如何收集和使用您的个人信息</p>
        <p>二、您如何管理您的个人信息</p>
        <p>三、我们如何共享、转让、公开披露您的个人信息</p>
        <p>四、我们如何存储和保护您的个人信息</p>
        <p>五、未成年人隐私权特别约定</p>
        <p>六、第三方责任说明</p>
        <p>七、本政策适用与修订</p>
      </div>
      <div>
        南京大衍数字科技有限公司深知个人信息对您的重要性，并会尽全力保护您的个人隐私信息安全可靠。我们致力于维持您对我们的信任，保护您的个人信息，恪守权责一致原则、目的明确原则、选择同意原则、最少够用原则、确保安全原则、主体参与原则、公开透明原则等要求。同时，承诺，我们将遵守并落实《网络安全法》的各项规定，依照业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。请您在使用我们的产品或服务前，仔细阅读本《隐私政策》，尤其是划线或加粗内容，了解我们对您个人信息的处置原则和保护措施。阅读过程中，如您有任何疑问或任何投诉意见，请与我们的客服、联系咨询。如您不同意协议中的任何发布或修订的条款，您可选择停止注册或注销账户，同时您应知晓，将无法再为您提供相关服务。
        本隐私政策中涉及的个人敏感信息，主要是用于电商服务的用户鉴别与授权信息，及在支付业务中收集、存储的，可识别特定自然人身份，以及金融消费者用于支付等业务的关键信息，支付机构用于内部使用的信息资产信息。此类信息经过组合、关联和分析后可能产生高敏感程度的信息，遭到未经授权的查看或未经授权的变更，会对支付等金融消费主体的个人信息安全与财产安全造成严重危害，包括但不限于：
        身份基本信息：
        <p>
          包括客户姓名、国籍、民族、性别、职业、住址、联系方式、婚姻状态、职业信息、手写签名、紧急联系人信息，以及客户有效身份证件的种类、号码、有效期限、签发机关及其正反面影印件
        </p>
        <p>网络身份标识信息：</p>
        <p>
          包括系统账号、IP地址、邮箱地址及与前述有关的密码、密码保护问题及其答案。
        </p>
        <p>个人常用设备信息：</p>
        <p>
          包括硬件型号、设备MAC地址、操作系统类型、IP地址、可变更设备识别码（如Android
          ID、IDFA、IDFV等在内的描述个人常用设备基本情况的信息）。
        </p>
        <p>生物识别信息：</p>
        <p>面部特征、语音信息。</p>
      </div>
      <div>
        <p>一、我们如何收集和使用您的个人信息</p>
        <p>为了您可以正常使用服务，下列情形下您需要向我们提供相关信息：</p>
        <p>（一）实名注册</p>
        <p>
          1、当您通过、官方门户、小程序注册账户或使用服务时，需要按照《非银行支付机构网络支付业务管理办法》的要求，提供您的姓名、国籍、性别、职业、住址、联系方式、有效身份证件的号码和有效期限以及绑定的银行卡信息（需要验证银行卡卡号、身份证号码、银行预留手机号、手机验证码）。如您未能提供上述信息，即未完成实名制验证，将无法注册账户或无法进行支付交易。同时为了验证该类信息的准确性和完整性，我们会将您提供的信息与合法传送至存有您信息的第三方机构（如政府机关、事业单位、商业银行、合法设立的商业化数据库等）进行实名制验证，我们会对该类验证机构提供的信息来源合法性进行稽核。
        </p>
        <p>
          2、因根据《支付机构反洗钱和反恐怖融资管理办法》等反洗钱相关法律、法规、规章及其他规范性文件要求，还需要您补充提供有效身份证件的彩色影印件以供我们核对并留存；如您未能提供，我们将无法为您注册账户或向您继续提供支付服务。
        </p>
        <p>（二）支付服务</p>
        <p>1、账户余额支付</p>
        <p>
          为了您能使用账户余额支付服务进行消费、转账以及购买产品，我们需要记录您的账户余额信息以及交易信息。如您不同意我们记录前述信息，可能无法使用余额支付服务，但不影响您使用我们提供的其他服务。
        </p>
        <p>2、快捷支付</p>
        <p>
          为了您能使用快捷支付服务，实现使用银行卡对账户余额的充值、提现以及基于银行卡的消费、转账及购买投资理财等金融类产品，您需提供您的银行卡卡号、身份证号码、银行预留手机号、手机验证码。我们会将前述信息与发卡银行进行验证。在您使用快捷支付服务时，我们需要记录您的交易信息。如您不提供前述信息，可能无法使用快捷支付服务，但不影响您使用我们提供的其他服务。
        </p>
        <p>
          我们承诺收集的支付信息依照中国银联《银联卡支付信息安全管理标准》要求，仅用于完成银联卡交易服务，不得用于除此之外的任何其他用途。
        </p>
        <p>3、转账</p>
        <p>
          为了准确执行您的支付指令，在您向他人的账户转账时，您可按照页面提示输入收款人账户、收款人部分姓名、转账金额，也可通过读取通讯录选择收款人账户。如您不提供读取通讯录权限，您仍可通过直接输入收款人信息使用我们提供的转账服务；如您不提供收款人信息，转账可能无法进行，但不影响您使用我们提供的其他服务。
        </p>
        <p>4、消费</p>
        <p>
          当您在商家进行消费时，我们需要按照法律法规及监管规定对商家进行管理，防范套现或欺诈风险，因此，我们将直接收集或向商家收集您的交易信息，包括交易金额、交易对象、交易商品、交易时间。如您不同意我们记录前述信息，则可能无法完成交易，但不影响您使用我们提供的其他服务。
        </p>
        <p>
          在使用二维码支付业务时，您可以选择开启手机的相机权限，使用摄像头设备扫一扫二维码完成付款服务，如您不提供前述权限，可能无法使用二维码支付服务，但不影响您使用我们提供的其他服务。
        </p>
        <p>5、卡充值账户</p>
        <p>
          当您使用卡充值账户时，我们需要您提供卡卡号、卡密码及充值金额；如您无法提供上述信息，可能无法完成充值服务，但不影响您使用我们提供的其他服务。
        </p>
        <p>6、客户服务</p>
        <p>
          我们会收集您使用客户服务时的搜索记录、您与客户服务团队联系时提供的信息及您参与问卷调查时向我们发送的信息。如您不提供前述信息，不影响您使用我们提供的其他服务。
        </p>
        <p>7、年度账单</p>
        <p>
          当您使用年度账单服务时，您需按照页面提示打钩，同意授权我们分析您近一自然年的登录日志、交易记录、理财收益、营销优惠信息，并可依据您的操作选择将您的年度账单海报分享至社交网络，我们不会将您的年度账单信息提供给第三方使用；如您不提供前述授权，我们将无法展示您的年度账单海报，但不影响您使用我们提供的其他服务。
        </p>
        <p>（三）支付安全</p>
        <p>
          为了准确预防钓鱼欺诈，保障您的账户安全，防范社会工程化攻击，提高支付交易服务的安全性，我们会通过了解您的设备信息、交易信息、地理位置、服务相关的日志信息来判断您的账号风险，排查并防范您的信息泄露和资金损失风险，并分析处理相关支付系统稳定性和兼容性问题。在必要时需要您通过选择人脸身份识别、支付密码验证等方式来核验本次操作系您本人完成。若您未能通过此次校验，我们将会采取阻断交易、冻结余额等措施保护账户资金安全，您可以通过人工客服申诉本次操作确实系您本人所为。
        </p>
        <p>（四）个性化服务</p>
        <p>
          我们会收集您使用服务时的交易信息、浏览信息、关注信息，进行数据统计分析，形成群体特征的用户画像，以便为您提供您感兴趣的个性化服务，如果您希望退订我们从短信渠道、电话渠道推送的商业广告，可以通过短信回复原号码TD和明确表达不接受此类外呼的方式申请退订服务。我们基于各种业务场景向您推送的账户动态、营销返利、应用服务消息，您也可通过客户端【消息中心】页签消息中的【设置】菜单，开启消息免打扰功能关闭此类消息推送。我们不会以任何方式和途径向您推送涉及隐私内容的商品服务信息，未经您明确授权我们不会出于满足第三方的营销需求而将您的个人信息提供给任何第三方。
        </p>
        <p>
          （五）您充分知晓，以下情形中，我们收集、使用个人信息无需征得您的授权同意：
        </p>
        <p>1、与国家安全、国防安全有关的；</p>
        <p>2、与公共安全、公共卫生、重大公共利益有关的；</p>
        <p>3、与犯罪侦查、起诉、审判和判决执行等有关的；</p>
        <p>
          4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
        </p>
        <p>5、所收集的个人信息是个人信息主体自行向社会公众公开的；</p>
        <p>
          6、从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；
        </p>
        <p>7、根据您的要求签订合同所必需的；</p>
        <p>
          8、用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；
        </p>
        <p>9、为合法的新闻报道所必需的；</p>
        <p>
          10、学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
        </p>
        <p>11、法律法规规定的其他情形。</p>
      </div>
      <div>
        <p>二、您如何管理您的个人信息</p>
        <p>
          1、您可通过门户网站登录账户，点击【我的】跳转【个人信息】，查阅您的身份、账户信息，或修改您的个人资料，如更换头像、账户手机号、账户邮箱地址，修改昵称、职业分类、联系地址，重新上传更新和认证您的身份证件信息，但出于安全性和身份识别的考虑或根据法律法规的强制规定，您可能无法修改注册时提供的初始认证信息。
        </p>
        <p>
          2、您可在门户网站登录账户，在【我的-个人中心-我的银行卡管理】中，以及从客户端登录账户，在【我的】页签银行卡入口中对绑定的银行卡进行管理，如删除既有绑定银行卡、增加绑定银行卡。
        </p>
        <p>3、您可通过如下路径注销账户：</p>
        <p>
          （1）客服电话路径：请您用账户绑定的手机号联系我们，核实账户信息后，我们将会在3个工作日内为您完成销户。
        </p>
        <p>
          4、在您仔细阅读《账户注销协议》，并选择注销您的账户后，您该账户内的所有信息将被清空，我们将不会再收集、使用或共享与该账户相关的个人信息，但之前的信息我们仍需按照国家监管要求进行强加密保存，且在该依法保存的期间受有权机关指令，提供有权机关查询，保存周期及超期处置方式请阅读“我们如何存储和保护您的个人信息”章节。
        </p>
        <p>
          5、如您发现我们采集、使用您个人信息的行为，违反了法律法规规定或违反了与您的约定，您可联系客服，要求删除该违反行为下采集的您的个人信息，如您在约定外要求删除的，可能会造成对您提供服务的影响或停止。
        </p>
        <p>
          6、如您发现我们收集、储存的您的个人信息有错误的，或者您本人的个人认证信息发生变更的，可以联系我们的客服或通过在线客服要求更正。
        </p>
        <p>
          7、在响应您上述5、6项要求前，为保障安全，我们可能需要您提供书面请求，或以其他方式证明您的身份，验证通过后将在三个工作日内处理完成；有特殊情形的，将在不超过法律法规规定期限内答复您的请求。
        </p>
        <p>
          8、如果我们停止运营某一产品或者服务，我们将及时停止收集和使用您的个人信息，同时将停止运营的通知通过短信、门户资讯中心、消息中心、微博和微信公众号等渠道告知您，我们将在法律、行政法规规定的必需期限到期后，对保存的个人信息进行匿名化处理或删除。当我们发现我们控制的个人信息发生或者可能发生泄露、毁损、丢失的情形，将会立即启动应急预案，采取补救措施消减影响和控制损失，并将事件相关情况及时通过短信、门户资讯中心、消息中心、微博和微信公众号等渠道告知您。
        </p>
        <p>
          9、尽管有上述约定，但按照法律法规要求，在以下情形下，我们可能无法响应您的请求：
        </p>
        <p>(1)与国家安全、国防安全有关的；</p>
        <p>(2)与公共安全、公共卫生、重大公共利益有关的；</p>
        <p>(3)与犯罪侦查、起诉和审判等有关的；</p>
        <p>(4)有充分证据表明您存在主观恶意或滥用权利的；</p>
        <p>(5)响应您的请求将导致其他个人、组织的合法权益受到严重损害的。</p>
      </div>
      <div>
        <p>三、我们如何使用 Cookie：</p>
        <p>
          为使您获得更轻松的访问体验，我们可能会在您享受个性化服务的同时，向您的计算机或移动设备上发送一个或多个Cookie的小数据文件，指定给您的Cookie是唯一的，它只能被将Cookies发布给您域中的Web服务器读取。您接受的Cookies存储您的浏览习惯和偏好设置等数据，进而帮助判断您的登录状态以及账户或数据安全，优化您对广告的选择与互动，您可以修改浏览器相关设置，以关闭Cookie的使用或删除存储的Cookies，但可能会影响您使用提供的支付服务或安全保障。
        </p>
      </div>
      <p>四、我们如何共享、转让、公开披露您的个人信息</p>
      <p>（一）共享</p>
      <p>
        我们仅基于产品与/或服务的业务场景，部署第三方插件或代码，与第三方共享您的信息，第三方包括关联公司、外部实名信息验证机构、合作的金融机构以及其他合作伙伴。我们会按照法律法规及相关国家标准要求，以弹框提示、确认授权、电子协议等多种形式征得您的同意，或确认第三方已征得您的同意，您可以授权通过服务器后台传输共享您的个人信息（如手机号、昵称、头像、账户余额）便于免密登录访问或创建第三方电商网站账户，同时在客户端【我的】页签【设置】菜单的【账户与隐私】中提供了授权管理的功能，您可以查询共享信息的第三方机构身份和信息内容，有权选择撤回同意，控制分享信息的范围，针对关闭授权服务的第三方我们将不再共享您的相应个人信息。但请您注意，但您关闭授权撤回同意的决定，不会影响此前基于您的授权而开展的个人信息处理，这些信息仍可能由不受我们控制的第三方独立保存，对于我们与之共享信息的第三方，我们会在完成并通过针对第三方的信息安全风险评估后，与其签署必要的保密协定，要求他们严格遵守相关法律法规与监管要求，遵照隐私政策采取保密和安全措施来处理个人信息，未经您的授权严禁用于营销活动或其他处理活动。
      </p>
      <p>
        1、我们提供的第三方产品与/或服务，可能由第三方提供或第三方联合我们提供，因此只有共享您的信息，才能实现我们的产品与/或服务的核心功能或提供您需要的服务。
        例如：您使用我们的生活缴费服务时，我们需要把您填写的户号和加油卡号等信息提供给合作的公共事业单位，才能使您完成缴费；您通过使用金融产品时，我们需要依据金融产品所属行业的监管法律法规要求，提供您的有效证件信息及其正反面影印件、人脸识别信息、婚姻状态、职业信息、手写签名、联系方式、紧急联系人相关信息、收入信息、中国纳税人声明，以保证您完成购买流程合规性要求以及保证您的资产准确无误的登记；
      </p>
      <p>
        2、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须情况进行提供；
      </p>
      <p>
        3、在法律法规允许且不违背公序良俗的范围内，为维护、的关联方、您或其他用户或社会公共利益、财产或安全免遭损害而有必要提供，比如为防止欺诈等违法活动和减少信用风险，而与其他公司和组织交换信息。不过，这并不包括违反本隐私政策中所作的承诺而为获利目的出售、出租、共享或以其它方式披露的个人信息。我们的关联方无权将个人信息共享用于任何其他用途，我们的关联方如要改变个人信息的处理目的，将再次通过公告公示、弹框授权等方式，征求您的授权同意；
      </p>
      <p>4、应您需求为您处理您与他人的纠纷或争议；</p>
      <p>（二）转让</p>
      <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
      <p>1、事先获得您明确的同意或授权；</p>
      <p>
        2、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；
      </p>
      <p>
        3、符合与您签署的相关协议（包括在线签署的电子协议以及相应的平台规则）或其他的法律文件约定所提供。
      </p>
      <p>
        4、在涉及收购、兼并、重组、资产转让或破产清算时，如涉及到个人信息转让，我们会向您告知有关情况，并要求新的持有您个人信息的公司、组织继续受此隐私政策的约束。如变更个人信息使用目的时，我们将要求该公司、组织重新向您征求授权同意。
      </p>
      <p>（三）公开披露</p>
      <p>原则上我们不会将您的信息进行公开披露，但以下情形除外：</p>
      <p>
        1、根据您的需求，在您明确同意或授权的披露方式下披露您所指定的个人信息；
      </p>
      <p>
        2、根据法律法规的要求、强制性的行政执法或司法要求所必须提供您个人信息的情况下，我们可能会依据所要求的个人信息类型和披露方式，在法律法规许可的前提下，采取符合业界标准的安全防护措施的前提下公开披露您的个人信息。
      </p>
      <p>五、我们如何存储和保护您的个人信息</p>
      <p>
        1、遵照《网络安全法》规定，我们在中华人民共和国境内收集和产生的个人信息将存储在中华人民共和国境内，我们在境外提供的扫码支付产品，使用支付标记化技术保障支付信息的安全性，在当地未留存个人信息。作为持有支付业务许可证的支付机构，当您注销您的账户后，我们将会按照《支付机构反洗钱和反恐怖融资管理办法》规定的期限，保存您的身份资料、交易记录为期五年，超出期限后将对您的个人信息进行匿名化处理或删除。
      </p>
      <p>
        2、在发放代金券、返利权益金、积分、早起打卡随机瓜分奖金业务场景中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些觉得显著影响您的合法权益，您有权提出申诉要求我们做出解释，我们也将提供适当的补偿控制措施。
      </p>
      <p>
        3、我们已使用符合业界标准的安全防护措施保护您提供的个人信息，采取措施保护数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，确保您个人信息的安全性、完整性、真实性、有效性。
      </p>
      <p>六、未成年人隐私权特别约定</p>
      <p>
        若您是18周岁以下未成年人，请您的父母或监护人阅读本政策，并在征得的您父母或监护人同意的前提下使用我们的服务或向我们提供您的信息，根据国家相关法律法规的规定要求保护未成年人的个人信息。如您的父母或监护人不同意您按照本政策使用我们的服务或向我们提供信息，请您立即终止使用我们的服务并及时通知我们，以便我们采取相应的措施。若您是不满14周岁的儿童，依据《儿童个人信息网络保护规定》制定如下儿童个人信息网络保护特别条款，请您和您的父母或监护人仔细阅读。我们承诺当收集、存储、使用、转移、披露儿童个人信息时，遵循正当必要、知情同意、目的明确、安全保障、依法利用的原则，并以显著、清晰的方式告知您的父母或监护人征得其同意。
      </p>
      <p>（一）我们如何征得儿童的父母或监护人授权同意：</p>
      <p>
        1、当您登录账户时，您需要完成必要的身份信息认证步骤，并通过核验后方能完成账户实名：
      </p>
      <p>
        （1）请您和您的父母或监护人仔细阅读《服务协议》和《隐私政策》中涉及儿童个人信息保护的特别条款，并通过勾选协议征得您的父母或监护人授权同意；
      </p>
      <p>
        （2）请填写您的户口簿相关登记信息，包括您的姓名、身份证号、性别、联系地址以及职业；
      </p>
      <p>
        （3）请经得您的父母或监护人授权同意，上传您的父母或监护人有效身份证的彩色影印件，并通过实名制验证；
      </p>
      <p>
        （4）请证明您和您的父母或监护人的监护关系，包括上传您的户口簿户主页、监护人信息页以及儿童本人信息页，并提交审核；
      </p>
      <p>
        2、当我们针对特别条款的告知事项发生实质性变化时，我们将再次征询您的父母或监护人的授权同意，请您的父母或监护人阅读“本政策适用与修订”章节，具体了解涉及变化的范围和我们采取的措施；
      </p>
      <p>
        3、建议您将特别条款及身份认证要求，与您的父母或监护人分享，若您或您的父母或监护人，对您的儿童个人信息有相关疑问时，请阅读“如何联系我们”章节，与的儿童个人信息保护专人进一步沟通。
      </p>
      <p>（二）我们如何处置停止服务和应急响应事件：</p>
      <p>
        1、当我们停止运营某一产品或者服务时，会将停止运营的通知及时通过短信、门户资讯中心、消息中心、微博和微信公众号等渠道告知儿童的父母或监护人，并立即停止收集这类产品或服务涉及的儿童个人信息，我们将在法律、行政法规规定的必需期限到期后，对这类产品或服务涉及的儿童个人信息进行匿名化处理或删除；
      </p>
      <p>
        2、当我们发现我们控制的儿童个人信息发生或者可能发生泄露、毁损、丢失的情形，将会立即启动应急预案，采取补救措施消减影响和控制损失，并将事件相关情况及时通过短信、门户资讯中心、消息中心、微博和微信公众号等渠道告知影响的儿童及其父母或监护人。
      </p>
      <p>七、第三方责任说明</p>
      <p>
        1、如您通过我们的网站或客户端，使用了由第三方而非提供的服务时，我们会尽力确保您的账号安全，使您获得更安全的访问体验，我们会使用专用的传输层安全协议，帮助您识别防范钓鱼、账号泄露等风险，同时更有利于保障您和第三方的共同权益，尽力阻止不法分子篡改您和您希望访问的第三方之间正常服务内容，确保您的个人信息在传输过程中的安全。
      </p>
      <p>
        2、您通过我们客户端接入使用的第三方服务，查看第三方创建的网页或使用第三方开发的应用程序时，向您提示这些第三方可能会放置他们自己的Cookies，这些Cookies不受我们的控制，且它们的使用不受本政策的约束，您应当进行关注。我们对第三方服务提供方对您的个人信息采取保护措施会尽到法律规定的义务，但我们无法保证这些主体一定会按照我们的要求标准采取保护措施，如果您发现这些第三方服务存在风险时，建议您终止相关操作以保护您的合法权益。服务提供方应有自己的独立隐私权保护政策，您使用的第三方服务受其隐私政策约束，建议您仔细阅读其政策内容。
      </p>
      <p>八、本政策适用与修订</p>
      <p>
        所有服务均适用本政策，我们的隐私政策可能因功能变更、业务变化、服务更新、监管要求等原因而随之修订。未经您明确同意，我们不会减少您按照本隐私政策所应享有的权利。我们会在网站、移动端上更新政策版本，同时在生效前通过网站公告资讯发布或以其他适当方式提醒您相关内容的更新。对于重大变更，我们还会提供更为显著的通知，包括但不仅限于短信通知、客户端消息中心等，说明隐私政策的具体变更内容，您可以通过客户端【我的】页签【设置】页面中的【账户与隐私】入口，访问阅读最新版的《隐私政策》。
      </p>
      <p>本政策所指的重大变更包括但不限于：</p>
      <p>
        1、我们的服务模式发生重大变化。如处理个人信息的目的、类型及使用方式等；
      </p>
      <p>2、个人信息共享、转让或公开披露的主要对象发生变化；</p>
      <p>3、您参与个人信息处理方面的权利及其行使方式发生重大变化；</p>
      <p>4、我们负责处理个人信息安全的联络方式及投诉渠道发生变化时；</p>
      <p>
        5、个人信息安全影响评估报告以及敏感信息内部审计报告表明存在高风险时。
      </p>
      <div class="confirm-btn" @click="goback">确定</div>
    </div>
    <div v-if="agreementType == 2">
      <div class="agreement-title">平台用户服务协议</div>
      <p>
        服务协议（以下简称“本协议”）由南京大衍数字科技有限公司（以下简称“本公司”）和您（也称“用户”）
      </p>
      <p>签订。</p>
      <p>一、声明与承诺</p>
      <p>
        （一）在接受本协议或您以本公司允许的其他方式实际使用本公司服务之前，请您仔细阅读本协议的全部内容（特别是以粗体标注的内容）。
      </p>
      <p>
        （二）如果您不同意本协议的任意内容，或者无法准确理解本公司对条款的解释，请不要进行后续操作，包括但不限于不要接受本协议、不使用本服务。如果您对本协议的条款有疑问，请通过本公司客服渠道进行询问，本公司将向您解释条款内容。
      </p>
      <p>
        （三）本公司需要对本协议进行变更或修改的，将通过手机客户端公告提前予以公布，若您未在公告期内提出异议，公告期限届满后即时生效；若您在公告期内提出异议，大衍将与您协商解决。
      </p>
      <p>
        （四）如您为无民事行为能力人或为限制民事行为能力人，例如您未满18周岁，则您应在监护人监护、指导下审慎阅读本协议并使用本服务。若您非自然人，则您确认，在您取得大衍账户时，或您以其他本公司允许的方式实际使用大衍服务时，您为在中国大陆地区合法设立并开展经营活动或其他业务的法人或其他组织，且您订立并履行本协议不受您所属、所居住或开展经营活动或其他业务的国家或地区法律法规的排斥。不具备前述条件的，您应立即终止注册或停止使用大衍服务。
      </p>
      <p>
        （五）您在使用本公司大衍服务时，应自行判断交易对方是否具有完全民事行为能力并自行决定是否使用大衍服务与对方进行交易，且您应自行承担与此相关的风险。
      </p>
      <p>
        （六）您承诺不利用本公司提供的商城服务从事或者协助他人从事非法活动，不得存在制作、发布、传播违法信息等行为，您实施的所有行为均遵守国家相关法律、法规、部门规章等规范性文件和本公司的相关规定，不违反社会公共利益或公共道德。您从事非法活动或不正当交易产生的一切后果与责任，由您独立承担。
      </p>
      <p>
        （七）如果您提供任何不真实、不准确、不完整或不能反映当前情况资料的，或本公司有合理理由怀疑该等资料不真实、不准确、不完整或不能反映当前情况的，本公司保留停止您使用大衍服务的权利，如因您资料的不真实、不准确、不完整或不能反映当前情况而给本公司或其关联公司或任何其他第三方造成损失的，您应负责赔偿。
      </p>
      <p>二、我们如何收集您的个人信息</p>
      <p>
        我们会遵循正当、合法、必要的原则，出于本政策所述的以下目的，收集和使用您在使用产品与/或服务过程中主动提供或因使用产品与/或服务而产生的个人信息，以及从第三方获取您的相关个人信息。如果我们要将您的个人信息用于本政策未载明的其它用途，或将基于特定目的收集而来的信息用于其他目的，我们将以合理的方式向您告知，并在使用前再次征得您的同意。
      </p>
      <p>（一）我们如何收集您的信息</p>
      <p>我们会通过如下三种渠道获取您的个人信息：</p>
      <p>
        1、您直接提供的信息：我们可能收集并存储您在使用电商服务时向我们提供的信息，包括您在我们页面中在线填写信息时、申请产品与/或服务时、参与网络社区讨论时、解决争议或就电商服务与我们联系时所提供的信息，以及您在使用我们服务过程中产生的关于您的交易和活动的信息。
      </p>
      <p>（二）我们收集您的哪些信息</p>
      <p>
        在实现电商服务以下各项业务功能的过程中，我们需要收集您的一些信息，用以向您提供服务、提升我们的服务质量、保障您的账号和资金安全以及符合国家法律法规及监管规定。请您注意，如果您提供的是他人个人信息，请您确保已取得相关主体的授权。
      </p>
      <p>1、账号注册与登录</p>
      <p>
        电商服务中的账号登录服务由我司提供，您需要注册账号登录电商服务。在此过程中，为对您的账号进行验证以实现登录目的，大衍将按照《隐私政策》的约定收集、存储您的账号名、密码、手机号码用于账号注册与登录的基础账号信息和您自行选择补充提供的头像、昵称等其他账号信息，请您在使用账号登录功能前仔细阅读《用户注册协议》、《隐私政策》项下的相关内容。同时，在您使用账号登录电商服务的过程中，为将您的账号与您在电商服务上的操作行为相关联，我们将向大衍收集您的账号信息，包括账号名、手机号码、昵称、头像，收集这些信息是用于为您提供账号登录服务以及保障您的账号安全，若您不提供上述信息，则您无法正常登录电商服务。
      </p>
      <p>2、实名认证</p>
      <p>
        在您使用支付服务、信用服务、退款服务、佣金服务、商城服务时，为了遵守适当性管理及履行反洗钱、羊毛党要求，我们需要首先认证您身份的真实性，为此您需要提供您的身份基本信息（姓名、性别、国籍、职业、住所地或者工作单位地址、手机号、身份证件或者身份证明文件的种类、号码和有效期限信息；在发生法律法规及监管规定的特定情形时，还需要您提供身份证件彩色照片或影印件以供我们核对并留存。根据相关法律法规的规定，您需通过身份基本信息多重交叉验证后方可使用我们的服务。在进行多重身份验证时，若通过绑定银行卡进行身份实名认证的，我们还需要您提供银行卡信息和银行预留手机号；若通过刷脸进一步确认您提供信息的准确性时，我们还需要您提供脸部图像/视频。我们会将上述信息提交给合法持有您上述信息的第三方身份验证机构，以便对您所提供信息的准确性进行核对如果您不提供上述信息或您的实名验证未通过，则您无法使用上述服务。
      </p>
      <p>3、商城服务功能</p>
      <p>
        您在使用电商服务商城服务功能，包括支付、转账、信用卡还款、红包、扫一扫、付款码、刷脸支付、指纹支付、支付优惠时，我们将会使用您的姓名、国籍、性别、职业、住址、联系方式、身份证件的种类、号码和有效期、账号、开户行、银行卡号、银行预留手机号、银行卡有效期、订单信息、交易记录、转账记录、面部信息、指纹验证结果信息，为您提供商城服务，如您不提供上述信息，我们无法提供相关商城服务或功能。
      </p>
      <p>4、提供客户服务及进行投诉处理</p>
      <p>
        我们的客服系统会使用您的账号信息和交易信息、支付信息。为保证您的账号安全，我们的呼叫中心客服和在线客服会使用您的账号信息与您核验您的身份。当您需要我们提供与您交易信息相关的客服与售后服务时，我们将会查询您的交易信息。此外，我们还会收集您与客服联系时您反馈意见、建议或举报时提供的信息，您参与问卷调查时向我们发送的信息。如您不提供前述信息，不影响您使用我们提供的其他服务。
      </p>
      <p>5、广告功能</p>
      <p>
        为更好地向用户提供服务，我们还可能通过站内信、PUSH通知、手机短信、电话方式向您推送我们认为您可能会感兴趣的广告和其它商业信息，如您不想收到此类广告的通知，可以根据本政策进行退订。
      </p>
      <p>
        为了向您提供更契合您需求的服务，我们可能会将您的注册信息、交易信息、浏览信息、关注的信息和我们自行采集的您的个人信息进行关联并进行数据分析以形成客户画像，用来向您推荐您感兴趣的产品和/或服务。如果您不想收到个性化推荐内容，您可以关闭相关功能。
      </p>
      <p>三、征得授权同意的例外</p>
      <p>
        依据相关法律法规及国家标准，以下情形中，我们可能会依法收集并使用您的个人信息无需征得您的同意：
      </p>
      <p>1、与国家安全、国防安全直接有关的；</p>
      <p>2、与公共安全、公共卫生、重大公共利益直接有关的；</p>
      <p>3、与犯罪侦查、起诉、审判和判决执行等直接有关的；</p>
      <p>
        4、出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；
      </p>
      <p>5、所收集的个人信息是个人信息主体自行向社会公众公开的；</p>
      <p>6、从合法公开披露的信息中收集的您的个人信息的；</p>
      <p>7、根据您的要求签订和履行合同所必需的；</p>
      <p>
        8、用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置服务的故障；
      </p>
      <p>9、法律法规规定的其他情形。</p>

      <p>四、我们如何使用您的个人信息</p>
      <p>
        1、为了遵守国家法律法规及监管要求，以及向您提供服务及提升服务质量，或保障您的账号和资金安全，我们会在以下情形中使用您的信息：
      </p>
      <p>（1）实现本政策“我们收集您的哪些信息”约定的目的。</p>
      <p>
        （2）为了保障服务的稳定性与安全性，我们会将您的信息用于身份验证、安全防范、诈骗监测、预防或禁止非法活动、降低风险、存档和备份用途。
      </p>
      <p>（3）为了使您知晓使用我们服务的状态，我们会向您发送服务提醒。</p>
      <p>（4）根据法律法规或监管要求向相关部门进行报告。</p>
      <p>（5）邀请您参与我们服务有关的客户调研。</p>
      <p>（6）提高、完善和优化电商服务在线服务。</p>
      <p>（7）处理您对电商服务产品与/或服务的申请或反馈请求。</p>
      <p>
        （8）我们通过技术手段对数据进行去标识化处理后，去标识化处理的信息将无法识别主体。请您了解并同意，在此情况下我们有权使用已经去标识化的信息；在不透露您个人信息的前提下，我们有权对用户数据库进行分析并予以商业化的利用。
      </p>
      <p>
        （9）我们会对我们的产品与/或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的产品与/或服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。
      </p>
      <p>
        2、当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏展示，以保护您的信息安全。
      </p>
      <p>
        3、当我们要将您的个人信息用于本政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。请您理解，我们向您提供的产品与/或服务将不断更新变化。如果您选择使用本政策中尚未列明的其他产品与/或服务时，在我们收集您的个人信息前，我们会通过业务协议、页面提示的方式向您详细说明信息收集的目的、方式、范围并征求您的明确同意。若您不同意提供前述信息，您可能无法使用该项服务，但不影响您使用其他服务。2、当我们展示您的个人信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏展示，以保护您的信息安全。
      </p>
      <p>五、我们如何委托处理、共享、转让、公开披露您的个人信息</p>
      <p>（一）委托处理</p>
      <p>
        为了提高效率、降低成本，我们可能会委托关联公司或其他专业服务提供商代表我们来处理信息，例如我们会聘请服务提供商为我们提供基础设施技术服务、信贷审批服务、客户支持服务。对我们委托处理个人信息的公司、组织和个人，我们会通过书面协议、现场审计等方式要求其遵守严格的保密义务并采取有效的保密措施，要求其只能在委托范围内处理您的信息，而不得出于其自身利益使用您的信息。
      </p>
      <p>（二）共享</p>
      <p>
        我们不会与电商服务以外的任何公司、组织和个人共享您的个人信息，除非获得您的明确同意或属于“共享、转让、公开披露个人信息时事先征得授权同意的例外”。我们可能会向关联公司、合作伙伴等第三方共享您的个人信息，以保障为您提供的服务顺利完成；但我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。该等第三方无权将共享的个人信息用于任何其他用途。对我们与之共享个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的协议、本政策要求的保密和安全措施来处理个人信息。在个人敏感数据使用上，我们要求第三方采用数据脱敏和加密技术，从而更好地保护用户数据。我们将按照法律法规及国家标准的要求以点击确认协议、具体场景下的点击确认动作等形式征求您的同意。
      </p>
      <p>（三）转让</p>
      <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
      <p>1、在获得您的明确同意后，我们会向其他方转让您的个人信息；</p>
      <p>
        2、根据适用的法律法规、法律程序的要求、强制性的行政或司法要求所必须的情况进行提供；
      </p>
      <p>
        3、在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。
      </p>
      <p>（四）公开披露</p>
      <p>
        除在公布中奖活动名单时会脱敏展示中奖者手机号或账号名外，我们仅会在以下情况下，才会公开披露您的个人信息：
      </p>
      <p>
        1、获得您的明确同意后，按您明确同意的披露方式披露您所指定的个人信息；
      </p>
      <p>
        2、在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。在符合法律法规的前提下，当我们收到上述披露信息的请求时，我们会要求必须出具与之相应的法律文件，如传票或调查函。我们坚信，对于要求我们提供的信息，应该在法律允许的范围内尽可能保持透明。我们对所有的请求都进行了慎重的审查，以确保其具备合法依据，且仅限于执法部门因特定调查目的且有合法权利获取的数据。
      </p>
      <p>（五）共享、转让、公开披露个人信息时事先征得授权同意的例外</p>
      <p>
        根据相关法律法规及国家标准，以下情形中，我们共享、转让、公开披露您的个人信息不必事先征得您的授权同意：
      </p>
      <p>1、与您履行法律法规规定的义务相关的；</p>
      <p>2、与国家安全、国防安全直接相关的；</p>
      <p>3、与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p>4、与刑事侦查、起诉、审判和判决执行等直接相关的；</p>
      <p>
        5、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；
      </p>
      <p>6、您自行向社会公众公开的个人信息；</p>
      <p>
        7、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。
      </p>
      <p>六、我们如何保护您的个人信息</p>
      <p>（一）我们保护您个人信息的技术与措施</p>
      <p>
        我们非常重视个人信息安全，并采取一切合理可行的措施，保护您的个人信息：
      </p>
      <p>1、数据安全技术措施</p>
      <p>
        我们已采用符合业界标准的安全防护措施以及行业内通行的安全技术来防止您的个人信息遭到未经授权的访问、修改，避免您的个人信息泄露、损坏或丢失：
      </p>
      <p>
        （1）采取加密技术对您的个人信息进行加密存储，我们存储您个人数据的系统已通过
        PCI
        DSS（第三方支付行业数据安全标准）认证，从安全管理、策略、过程、网络体系结构等诸多方面保障交易及个人信息安全。
      </p>
      <p>
        （2）我们的网络服务采取了传输层安全协议等加密技术，通过https等方式提供浏览服务，确保您的个人信息在传输过程中的安全。
      </p>
      <p>
        （3）在使用您的个人信息时，例如个人信息展示、个人信息关联计算，我们会采用包括内容替换、SHA256在内的多种数据脱敏技术增强个人信息在使用中的安全性。
      </p>
      <p>
        （4）我们会采用白盒代码安全检测、黑盒安全测试、入侵检测防御技术进行恶意代码防范措施保护您的个人信息安全。
      </p>
      <p>2、为保护个人信息采取的其他安全措施</p>
      <p>
        我们通过建立数据分类分级、数据安全管理规范、安全开发规范来管理规范个人信息的存储和使用：
      </p>
      <p>
        （1）我们采用严格的数据访问权限和多重身份认证技术控制和保护个人信息，通过与信息接触者签署严格的保密协议、监控和审计机制来对数据进行全面安全控制，避免数据被违规使用。
      </p>
      <p>
        （2）我们采用代码安全检查、数据访问日志分析技术进行个人信息安全审计。
      </p>
      <p>
        （3）我们建立了信息安全委员会并下设信息安全小组，由各小组信息安全专员负责个人信息安全事务。
      </p>
      <p>
        （4）我们还会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。
      </p>
      <p>（二）我们如何存储和保存您的个人信息</p>
      <p>
        1、我们仅在本政策所述目的所必需期间和法律法规及监管规定的时限内保存您的个人信息。我们承诺为了保证您的消费者权益，除非法律法规另有规定，您的个人信息我们将保存至您账号注销之日后的两个月。当您的个人信息超出我们所保存的期限后，我们会对您的个人信息进行删除或匿名化处理。
      </p>
      <p>
        2、在您终止使用我们的服务后，我们会停止对您的信息的收集和使用，法律法规或监管部门另有规定的除外。如果我们终止服务或运营，我们将及时停止收集您个人信息的活动，至少提前三十天通知您，并在终止服务或运营后对您的个人信息进行删除或匿名化处理。
      </p>
      <p>七、您的权利</p>
      <p>
        电商服务非常重视您对个人信息的关注，按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，尽全力保障您对自己的个人信息行使以下权利：
      </p>
      <p>（一）访问您的个人信息</p>
      <p>
        1、您有权随时访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：
      </p>
      <p>（1）您的账号信息</p>
      <p>（2）您的交易信息</p>
      <p>（四）注销您的账户</p>
      <p>
        您可以在我们的产品与/或服务中直接申请注销账号或注销您申请的具体服务功能，还可以通过约定的联系方式与我们联系，经核实您的注销信息、您的合同履行情况等具体细节后，我们对您的注销账
      </p>
      <p>八、我们如何处理儿童的个人信息</p>
      <p>
        1、我们的产品、网站和服务主要面向成人。若您是14周岁以下的儿童，在使用我们的产品与/或服务或向我们提供您的个人信息前，应事先取得您家长或法定监护人的同意。
      </p>
      <p>
        2、对于经父母或其他监护人同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或其他监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。
      </p>
      <p>
        3、尽管当地法律和习俗对儿童的定义不同，但我们将不满14周岁的任何人视为儿童。
      </p>
      <p>
        4、如果我们发现自己在未事先获得可证实的父母或其他监护人同意的情况下收集了儿童的个人信息，或儿童的父母或其他监护人撤回其同意的，则会设法尽快删除相关数据。
      </p>
      <p>九、其他规定</p>
      <p>
        10.1
        如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。
      </p>
      <p>10.2 本协议中的标题仅为方便阅读而设，不应影响对本协议条款的理解。</p>
      <p>
        10.3
        隐私保护：保护用户隐私和其他个人信息是大衍的一项基本政策，具体内容详见大衍相关隐私政策。
      </p>
      <p>
        10.4
        鉴于有关法律法规正在持续不断的完善，如相关法律规定与本协议有冲突之处，以相关法律规定为准。
      </p>
      <p>十、意见及建议</p>
      <p>
        用户对大衍服务有任何意见或建议，可向大衍官方网站右下端标注的联系方式反馈，大衍愿意倾听并尊重每一位用户的意见，并将尽力为用户提供最优质的服务。
      </p>
      <div class="confirm-btn" @click="goback">确定</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "agreement",
  data: function() {
    return {
      agreementType: 1
    };
  },
  mounted: function() {
    var that = this;
    var type = that.$route.params.type;
    this.agreementType = type;
  },
  methods: {
    goback() {
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped>
.confirm-btn {
  font-size: 0.34rem;
  color: #fff;
  font-weight: bold;
  height: 0.86rem;
  border-radius: 0.43rem;
  text-align: center;
  line-height: 0.86rem;
  margin-top: 0.47rem;
  background-color: #eb3729;
}
.agreement-title {
  text-align: center;
  font-weight: bold;
  font-size: 22px;
  margin-top: 0.35rem;
  margin-bottom: 0.25rem;
}
</style>
